import { twMerge } from "tailwind-merge";
import Text from "../text/Text.react";
import stylesheet from "./index.module.css";

interface RadioButtonProps {
  className?: string;
  value: string;
  label?: string;
  listOfChoices: { id: string; title: string }[];
  choicesInRow?: boolean;
  onChange?: (value: string) => void;
  id?: string;
}

export default function RadioButton({
  value,
  label,
  listOfChoices,
  onChange = () => {},
  choicesInRow = false,
  id,
  ...props
}: RadioButtonProps) {
  const handleRadioChange = (id: string) => onChange(id);

  return (
    <>
      <div {...props}>
        <Text type="label">{label}</Text>
        <fieldset className={twMerge(stylesheet.fieldset, "focus:bg-red-500")}>
          <div
            className={twMerge(
              choicesInRow && "flex space-x-2",
              !choicesInRow && "flex-col space-y-5",
              "items-center"
            )}
          >
            {listOfChoices.map((choice) => (
              <div
                key={choice.id}
                className={twMerge(stylesheet.inputwrapper, "mt-2 flex cursor-pointer space-x-2")}
                onClick={() => handleRadioChange(choice.id)}
              >
                <input
                  id={choice.id}
                  name={"radiobutton_choice_" + id}
                  type="radio"
                  checked={choice.id === value}
                  onChange={() => handleRadioChange(choice.id)}
                  onClick={(e) => e.preventDefault()}
                  className={twMerge(
                    stylesheet.input,
                    "cursor-pointer border-slate-100 hover:ring-blue-900 sm:h-6 sm:w-6"
                  )}
                />
                <Text type="base" className={"font-semibold text-sm md:text-base"}>
                  {choice.title}
                </Text>
              </div>
            ))}
            <div className={stylesheet.div}></div>
          </div>
        </fieldset>
      </div>
    </>
  );
}
